import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { useUserStore } from "@/store/UserStore";
import { LogOut } from "lucide-react";
import { Profile } from "./Profile";
import { ServiceAgreementList } from "./ServiceAgreement";
// import PhoneChange from "./PhoneChange";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/Dialog";

import { X } from "lucide-react";

interface SettingsContentProps {
  onClose?: () => void;
}

export function SettingsContent({ onClose }: SettingsContentProps) {
  const { logout } = useUserStore();
  // const [currentView, setCurrentView] = useState<"main" | "phoneChange">(
  //   "main"
  // );

  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const handleLogout = () => {
    setShowLogoutDialog(false);
    logout();
  };

  // 手机号更换视图
  // if (currentView === "phoneChange") {
  //   return <PhoneChange onBack={() => setCurrentView("main")} />;
  // }

  // 主菜单视图
  return (
    <>
      {onClose && (
        <div className="relative flex items-center justify-end px-3 mt-3 bg-white top-0 z-10">
          <h2 className="text-base absolute left-1/2 -translate-x-1/2">设置</h2>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="w-5 h-5" />
          </Button>
        </div>
      )}
      <div className="flex flex-col h-full bg-white p-4 overflow-y-auto">
        <div className="text-xs text-gray-500 px-2 mb-2">个人资料</div>
        <Profile />
        <div className="text-xs text-gray-500 px-2 mb-2 mt-5">服务协议</div>
        <ServiceAgreementList />

        <div className="bg-white rounded-xl overflow-hidden gap-3 mt-5">
          <Button
            variant="ghost"
            onClick={() => setShowLogoutDialog(true)}
            className="w-full p-4 h-auto flex justify-start items-center bg-[#f8f8f8] gap-3 text-base"
          >
            <LogOut className="w-5 h-5" />
            <span>退出</span>
          </Button>
        </div>

        {/* 退出登录确认对话框 */}
        <Dialog open={showLogoutDialog} onOpenChange={setShowLogoutDialog}>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <LogOut className="w-5 h-5 text-gray-500" />
                退出登录
              </DialogTitle>
              <DialogDescription>你确定要退出登录吗？</DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  onClick={() => setShowLogoutDialog(false)}
                >
                  取消
                </Button>
                <Button variant="default" onClick={handleLogout}>
                  确认退出
                </Button>
              </div>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
